import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { FiGrid, FiHome, FiBox, FiSend, FiCpu, FiLayers, FiMenu } from "react-icons/fi";
import { UserAuth } from "../../context/authContext";

const MainLayout = ({ children, activeId, isRoomView = false }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const { user } = UserAuth();

  const sidebarItems = [
    { id: "home", title: "Home", Icon: FiHome, link: "/" },
    {
      id: "dashboard",
      title: isRoomView ? "Room Dashboard" : "Dashboard",
      Icon: FiGrid,
      link: isRoomView ? "/joinedroom" : "/dashboard",
    },
    ...(isRoomView
      ? [
          { id: "explorer", title: "Explorer", Icon: FiBox, link: "/etherscan" },
          { id: "transactions", title: "Transactions", Icon: FiSend, link: "/transaction" },
          { id: "mempool", title: "Mempool", Icon: FiCpu, link: "/mempool" },
          { id: "blocks", title: "Blocks", Icon: FiLayers, link: "/blocks" },
        ]
      : []),
  ];

  return (
    <div className="bg-background min-h-screen flex selection:bg-primary selection:text-white">
      <Sidebar
        user={user}
        showSidebar={showSidebar}
        onSidebarHide={() => setShowSidebar(false)}
        items={sidebarItems}
        selected={activeId}
        onSelect={() => {}} // Navigation handled by link/useNavigate in MenuItem
      />

      <div className="min-h-screen bg-background text-white sm:pl-64 w-full">
        {/* Mobile Top Bar */}
        <div className="sm:hidden p-4 flex items-center justify-between border-b border-white/10 bg-surface/50 backdrop-blur-md sticky top-0 z-40">
          <div className="flex items-center gap-2">
            <span className="font-bold text-primary">AstraHack</span>
          </div>
          <button
            onClick={() => setShowSidebar(true)}
            className="p-2 text-text-muted hover:text-white transition-colors"
          >
            <FiMenu size={24} />
          </button>
        </div>

        <div className="w-full p-4 md:p-10">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
